import useViewWaybill from "./useViewWaybill";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { motion } from "framer-motion";
import primaryComponents from "../../../../../components/primaryComponents";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { pathConstants } from "../../../../../routes/pathContants";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defaultDateDisplay } from "../../../../../helpers";

const ViewWaybill = () => {
  const { waybills, loadingWaybills } = useViewWaybill();
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Waybill Details"
      description="View the details of a waybill"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className={globalStyles.pageColumnGaps}
          >
            <Link
              to={pathConstants.PROCUREMENT_WAYBILLS}
              style={{ textDecoration: "none" }}
            >
              <primaryComponents.Button classNames="btn btn--outline">
                <FontAwesomeIcon
                  icon="angle-left"
                  className="mr-3"
                  style={{ fontSize: "18px" }}
                />
                <span>Back</span>
              </primaryComponents.Button>
            </Link>
            <secondaryComponents.LoaderHelper
              isLoading={loadingWaybills}
              classNames="mt-5"
            >
              <div className={globalStyles.pageHeaders}>
                <div>
                  <h4 className="font-weight-semibold">
                    <span className="muted--text">Waybill Number: </span>
                    {waybills?.id || "N/A"}
                  </h4>
                </div>
                <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
                  <primaryComponents.Button
                    onClick={() =>
                      window.open(
                        waybills?.waybill_url,
                        "_blank",
                        "noopener,noreferrer",
                      )
                    }
                    classNames="btn btn--primary"
                    isDisabled={!waybills?.waybill_url}
                  >
                    Download
                  </primaryComponents.Button>
                </div>
              </div>
              <div
                className={`${globalStyles.cardWithBorder} w-100`}
                style={{ background: "#fff", padding: "10px" }}
              >
                <div className={`${globalStyles.grid}`} style={{ gap: "20px" }}>
                  <div className="p-2">
                    <p className="dark--text small-text-size">Created on:</p>
                    <p className="smallest-text-size mt-2">
                      {defaultDateDisplay(waybills?.created_at) || "N/A"}
                    </p>
                  </div>
                  <div className="p-2">
                    <p className="dark--text small-text-size">Created by:</p>
                    <p className="smallest-text-size mt-2">
                      {waybills?.order?.initiator.full_name || "N/A"}
                    </p>
                  </div>
                  <div className="p-2">
                    <p className="dark--text small-text-size">Order ID:</p>
                    <p className="smallest-text-size mt-2">
                      {waybills?.order?.id || "N/A"}
                    </p>
                  </div>
                  <div className="p-2">
                    <p className="dark--text small-text-size">Customer:</p>
                    <p className="smallest-text-size mt-2">
                      {waybills?.order?.customer?.full_name || "N/A"}
                    </p>
                  </div>
                  <div className="p-2">
                    <p className="dark--text small-text-size">
                      Logistics Company :
                    </p>
                    <p className="smallest-text-size mt-2">
                      {waybills?.logistics?.company || "N/A"}
                    </p>
                  </div>
                  <div className="p-2">
                    <p className="dark--text small-text-size">Driver Name:</p>
                    <p className="smallest-text-size mt-2">
                      {waybills?.logistics?.driver_name || "N/A"}
                    </p>
                  </div>
                  <div className="p-2">
                    <p className="dark--text small-text-size">
                      Driver Phone Number:
                    </p>
                    <p className="smallest-text-size mt-2">
                      {"+" +
                        waybills?.logistics?.driver_phone_code +
                        waybills?.logistics?.driver_phone_number || "N/A"}
                    </p>
                  </div>
                  <div className="p-2">
                    <p className="dark--text small-text-size">
                      Vehicle Number:
                    </p>
                    <p className="smallest-text-size mt-2">
                      {waybills?.logistics?.vehicle_number || "N/A"}
                    </p>
                  </div>
                  <div className="p-2">
                    <p className="dark--text small-text-size">
                      Delivery Address:
                    </p>
                    <p className="smallest-text-size mt-2">
                      {waybills?.logistics?.delivery_address || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <secondaryComponents.ViewGenerateWaybillTable
                waybills={waybills}
              />
            </secondaryComponents.LoaderHelper>
          </motion.div>
        </>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default ViewWaybill;
